import { HttpClient } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class AccountService {
    private http = inject(HttpClient);
    private BASE_URL = environment.api.url;

    readonly isVerified = signal<boolean | null>(null);

    loadProviderStatus(email: string): void {
        this.http.get<boolean>(`${this.BASE_URL}/account/status`, {
            params: { email }
        }).subscribe({
            next: (verified) => {
                this.isVerified.set(verified)
            },
            error: () => {
                this.isVerified.set(false)
            }
        });
    }

    isLastTermOfUseAccepted(): Observable<boolean> {
        return this.http.get<boolean>(`${this.BASE_URL}/account/tou`);
    }

    acceptTermOfUse(): Observable<void> {
        return this.http.post<void>(`${this.BASE_URL}/account/tou`, {});
    }
}